import { render, staticRenderFns } from "./communityInfoManageList.vue?vue&type=template&id=12cab9b2&"
import script from "./communityInfoManageList.vue?vue&type=script&lang=js&"
export * from "./communityInfoManageList.vue?vue&type=script&lang=js&"
import style0 from "./communityInfoManageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports